
export const Types = {
    LOGIN: "LOGIN",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAILED: "LOGIN_FAILED",
    LOGOUT: "LOGOUT",
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
    LOGOUT_FAILED: "LOGOUT_FAILED",
    RESET_PASSWORD: "RESET_PASSWORD",
    RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
    RESET_PASSWORD_FAILED: "RESET_PASSWORD_FAILED",
    END_RESET_PASSWORD: "END_RESET_PASSWORD",
    START_RESET_PASSWORD: "START_RESET_PASSWORD"
};

export const loginAction = (username, password) => ({
    type: Types.LOGIN,
    username: username,
    password: password
});

export const loginSuccessAction = (accessToken, user) => ({
    type: Types.LOGIN_SUCCESS,
    accessToken: accessToken,
    user: user
});

export const loginFailedAction = (info) => ({
    type: Types.LOGIN_FAILED,
    ...info
});

export const logoutAction = () => ({
    type: Types.LOGOUT
});

export const logoutSuccessAction = () => ({
    type: Types.LOGOUT_SUCCESS
});

export const logoutFailedAction = () => ({
    type: Types.LOGOUT_FAILED
});

export const openForgotPasswordModal = () => ({
  type:Types.START_RESET_PASSWORD
});

export const resetPasswordAction = (data) => ({
    type: Types.RESET_PASSWORD,
    data: data
});

export const resetPasswordSuccessAction = () => ({
    type: Types.RESET_PASSWORD_SUCCESS
});

export const resetPasswordFailedAction = (error) => ({
    type: Types.RESET_PASSWORD_FAILED,
    error: error
});

export const closeResetPasswordModalAction = () => ({
  type: Types.END_RESET_PASSWORD
});



// WEBPACK FOOTER //
// ./public/pages/Login/actions.js